import request from '@/api/request'
import { get } from '@/api/request'

// 获取需求分页列表
export function getDemandPage(params) {
  return get('/app/admin/demand/list', params)
}

// 获取需求详情
export function getDemandDetail(id) {
  return get(`/app/admin/demand/${id}`)
}

// 分配需求给指定处理人
export function assignDemand(id, handlerId) {
  return request.put(`/app/admin/demand/${id}/assign`, null, {
    params: { handlerId }
  })
}

// 领取需求（当前用户成为处理人）
export function claimDemand(id) {
  return request.put(`/app/admin/demand/${id}/claim`)
}

// 拒绝需求
export function rejectDemand(id, remark) {
  return request.put(`/app/admin/demand/${id}/reject`, null, {
    params: { remark }
  })
}

// 关闭需求
export function closeDemand(id) {
  return request.put(`/app/admin/demand/${id}/close`)
}
